module.exports = __webpack_public_path__ + "img/descend-2.aeb6439a.png";